// Flag to prevent scroll listener interference during programmatic scrolling
let isScrollingProgrammatically = false;

function navigateToSection(button) {
  const targetSectionId = button?.getAttribute("data-target-id");
  const targetSection = document?.querySelector(targetSectionId);
  
  if (targetSection) {
    const headerHeight = document.querySelector('.main-wrapper-header')?.offsetHeight || 0;
    const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    
    // Set flag to prevent scroll listener from interfering
    isScrollingProgrammatically = true;
    
    // Update active state immediately
    document.querySelectorAll(".collection-slider-image-container").forEach((el) => {
      el.classList.remove("active-element");
    });
    button.classList.add("active-element");
    
    window.scrollTo({
      top: targetPosition,
      behavior: "smooth",
    });
    
    // Reset flag after scroll animation completes (approximate timing)
    setTimeout(() => {
      isScrollingProgrammatically = false;
    }, 1000); // Adjust timing if needed
    
  } else {
    console.warn(`No section found with ID "${targetSectionId}"`);
  }
}

// Function to update active navigation based on scroll position
function updateActiveNavigation() {
  // Don't update if we're in the middle of programmatic scrolling
  if (isScrollingProgrammatically) {
    return;
  }
  
  const headerHeight = document.querySelector('.main-wrapper-header')?.offsetHeight || 0;
  const threshold = headerHeight + 20; // Small offset from header
  
  const navigationButtons = document.querySelectorAll(".collection-slider-image-container");
  let activeButton = null;
  
  // Find the section that has just passed the threshold (closest to top but past it)
  let closestSection = null;
  let closestDistance = Infinity;
  
  navigationButtons.forEach((button) => {
    const targetSectionId = button.getAttribute("data-target-id");
    const targetSection = document.querySelector(targetSectionId);
    
    if (targetSection) {
      const sectionRect = targetSection.getBoundingClientRect();
      const sectionTop = sectionRect.top;
      
      // Check if section top has passed the threshold
      if (sectionTop <= threshold) {
        const distance = threshold - sectionTop;
        if (distance < closestDistance) {
          closestDistance = distance;
          closestSection = button;
        }
      }
    }
  });
  
  // If we found a section that has passed the threshold, use it
  if (closestSection) {
    activeButton = closestSection;
  } else {
    // If no section has passed threshold yet, use the first one
    if (navigationButtons.length > 0) {
      activeButton = navigationButtons[0];
    }
  }
  
  // Update active class
  if (activeButton) {
    navigationButtons.forEach((el) => {
      el.classList.remove("active-element");
    });
    activeButton.classList.add("active-element");
  }
}

// Throttle function to improve performance
function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

// Initialize navigation
const navigationButtons = document.querySelectorAll(".collection-slider-image-container");
navigationButtons.forEach((button) => {
  button.addEventListener("click", () => navigateToSection(button));
});

// Add scroll event listener with throttling for better performance
window.addEventListener("scroll", throttle(updateActiveNavigation, 100));

// Initial check on page load
document.addEventListener("DOMContentLoaded", updateActiveNavigation);